import React from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { campaignStages, reuseBlocks, screenshots } from '../../../data/deck';

/** Crop of the supplied campaign visual: the hook → Snak → report strip only. */
const SOURCE = {
  width: 2576,
  height: 1342
};
const CROP = {
  x: 440,
  y: 420,
  width: 1760,
  height: 620
};
export function CampaignSlide() {
  return <Slide id="campaign" data-id="element-134" data-mp="1bjtmr8ra9kk2">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-16" data-id="element-135" data-mp="1biijda1r2eth">
        <InView data-id="element-136" data-mp="16jp53fen2js9">
          <SlideHeadline lead="When a market needs more than an asset —" follow="we can help run the campaign." size="medium" data-id="element-137" data-mp="16l8k72ok6osg" />
        </InView>
        <InView delay={0.1} data-id="element-138" data-mp="30xglcxrh41wo">
          <p className="font-body text-[14.5px] leading-[1.7] text-[rgba(1,51,43,0.65)]" data-id="element-139" data-mp="30xoymqrid98e">
            An end-to-end, always-on rhythm: a hook brings dentists in, a Snak engages them,
            and every answer sharpens the next round.
          </p>
        </InView>
      </div>

      <InView delay={0.16} y={26} className="mt-12" data-id="element-140" data-mp="1dwb7d8h0zbyo">
        <figure className="rounded-[30px] bg-[#EFECE4] p-4 sm:p-6" data-id="element-141" data-mp="zvqsuoi582az">
          <div className="relative overflow-hidden rounded-[20px]" style={{
          aspectRatio: `${CROP.width} / ${CROP.height}`
        }} data-id="element-142" data-mp="zxk0o74hsskk">
            <img src={screenshots.campaignLoop} alt="Campaign sequence: a WhatsApp hook, three Snak screens with a clinical case, a question and feedback, and a campaign report on a laptop" className="absolute block max-w-none mix-blend-multiply" style={{
            width: `${SOURCE.width / CROP.width * 100}%`,
            left: `-${CROP.x / CROP.width * 100}%`,
            top: `-${CROP.y / CROP.height * 100}%`
          }} data-id="element-143" data-mp="1rny57cqm8sjk" />
          </div>

          <div className="mt-5 grid gap-4 sm:grid-cols-[22fr_46fr_32fr]" data-id="element-144" data-mp="2felrj31a3kpn">
            {campaignStages.map((stage, i) => <div key={stage.name} className="border-t border-[rgba(1,51,43,0.15)] pt-3" data-id="element-145" data-mp="2l6w9swrfwdaa" data-mpi={i}>
                <span className="font-body text-[10px] tabular-nums tracking-[0.2em] text-[rgba(1,51,43,0.4)]" data-id="element-146" data-mp="2g7t5xfn74d3w">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="ml-2 font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-background" data-id="element-147" data-mp="2bat2zdln7qh0">
                  {stage.name}
                </span>
                <p className="mt-1 font-body text-[13px] leading-snug text-[rgba(1,51,43,0.6)]" data-id="element-148" data-mp="21hc6u2y19za6">
                  {stage.detail}
                </p>
              </div>)}
          </div>

          <figcaption className="mt-5 flex justify-center" data-id="element-149" data-mp="1sjs2gl4vjmvc">
            <span className="inline-flex items-center gap-2 rounded-full bg-background px-4 py-2 font-body text-[11.5px] text-white" data-id="element-150" data-mp="1njnj8ncl0e1f">
              <ArrowsClockwise size={14} className="text-primary" aria-hidden="true" data-id="element-151" data-mp="1ikkqo2dsg0ac" />
              Continuous loop — every answer sharpens the next hook and question
            </span>
          </figcaption>
        </figure>
      </InView>

      <div className="mt-14 grid gap-10 border-t border-[rgba(1,51,43,0.12)] pt-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-center lg:gap-16" data-id="element-152" data-mp="1ieacpqm47pbe">
        <InView delay={0.22} data-id="element-153" data-mp="1ncv2ew3qqqll">
          <span className="font-body text-[10px] uppercase tracking-[0.22em] text-[rgba(1,51,43,0.45)]" data-id="element-154" data-mp="1nb0q266jc6t4">
            We don’t start from zero every time
          </span>
          <ul className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-155" data-mp="up7jdli4c812">
            {reuseBlocks.map(block => <li key={block} className="rounded-[16px] bg-white px-4 py-4 ring-1 ring-[rgba(1,51,43,0.08)]" data-id="element-156" data-mp="zlpmyi1pq0bt">
                <span className="block font-body text-[12px] text-[rgba(1,51,43,0.45)]" data-id="element-157" data-mp="14gc12sz6i6zl">Reuse</span>
                <span className="mt-0.5 block font-heading text-[18px] leading-tight text-background" data-id="element-158" data-mp="6xakeuzrpahd">
                  {block}
                </span>
              </li>)}
            <li className="col-span-2 rounded-[16px] border-2 border-dashed border-primary px-4 py-4 sm:col-span-1" data-id="element-159" data-mp="2dnngr1pu0dfb">
              <span className="block font-body text-[12px] text-[#05a63a]" data-id="element-160" data-mp="28mg870fv7a7l">Build</span>
              <span className="mt-0.5 block font-heading text-[18px] leading-tight text-background" data-id="element-161" data-mp="2nf9xteoup6pz">
                Only what’s missing
              </span>
            </li>
          </ul>
        </InView>

        <InView delay={0.3} data-id="element-162" data-mp="2wfpxed2h3tpk">
          <p className="font-heading text-[28px] leading-[1.1] tracking-[-0.02em] text-background sm:text-[36px]" data-id="element-163" data-mp="2sct9q7y2t7er">
            More frequent support and more{' '}
            <span className="relative whitespace-nowrap" data-id="element-164" data-mp="369ylmokh10hx">
              brand love
              <span aria-hidden="true" className="absolute -bottom-1 left-0 h-[3px] w-full rounded-full bg-primary" data-id="element-165" data-mp="31drfauo5xmzg" />
            </span>{' '}
            — <span className="text-[rgba(1,51,43,0.45)]" data-id="element-166" data-mp="170i2ou0bllcz">at manageable cost.</span>
          </p>
        </InView>
      </div>
    </Slide>;
}